import { useNavigate } from "react-router-dom";
import "./healthIncNotificaMessageBody.scss";

function HealthIncNotificaMessageBody({ notifText , btnText , btnLink ,state }) {

 let navigate = useNavigate();

//===Event handler start here===
const handelClicking = ()=>{
    navigate(btnLink ,{ state });
  }

//===Event handler end here===  

  return (
    <div className="healthInc_notif_cover">
   
        <span className="healthInc_notif_text" dir="rtl">{notifText}</span>
        
        <div className="healthInc_notifi_btns">
        <button className="healthInc_notif_btn" dir="rtl" onClick={()=>{handelClicking()}}>{btnText}</button>
        </div>

    </div>
  )
}

export default HealthIncNotificaMessageBody;